var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+"正答率的趋势")]),_c('div',{ref:"chart",staticClass:"line-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }